import { Routes, Route, Navigate } from "react-router-dom";
import SignUp from "../pages/auth/SignUp";
import SignIn from "../pages/auth/SignIn";
import Home from "../pages/Home";
import { Search, PlayerProfile } from "../pages/search";
import StaffProfile from "../pages/search/StaffProfile";
import AgentPublicProfile from "../pages/search/AgentPublicProfile";
import PrivateRoute from "./PrivateRoute";
import Onboarding from "../pages/auth/Onboarding";
import ClubTenders from "../pages/club/ClubTenders";
import CreateTender from "../pages/club/CreateTender";
import EditTender from "../pages/club/EditTender";
import MyClub from "../pages/club/MyClub";
import ChangePlayerAvailability from "../pages/club/ChangePlayerAvailability";
import InviteStaffPage from "../pages/club/InviteStaffPage";
import ViewPitches from "../pages/club/ViewPitches";
import ClubProfile from "../pages/search/ClubProfile";
import Discovery from "../pages/Discovery";
import Compare from "../pages/Compare";
// Team of the Week (TP_TOTW_BRIEF) — Tools page over the Best-Lineup mirror.
import TeamOfTheWeek from "../pages/totw/TeamOfTheWeek";
import Market from "../pages/Market";
import TransferNews from "../pages/TransferNews";
// Competitions (TP-CompetitionPage build): browse + competition page over the
// TheSports mirror. All signed-in roles, non-KYC viewable (see PrivateRoute).
import CompetitionsBrowse from "../pages/competitions/CompetitionsBrowse";
import CompetitionPage from "../pages/competitions/CompetitionPage";
import WhatsNew from "../pages/WhatsNew";
import ArticleDetailPage from "../pages/ArticleDetailPage";
import Events from "../pages/Events";
import Organizers from "../pages/Organizers";
import Lawyers from "../pages/lawyer/Lawyers";
import LawyerRequests from "../pages/lawyer/LawyerRequests";
import SentInvitations from "../pages/SentInvitations";
import AgentTenders from "../pages/agent/AgentTenders";
import MySquad from "../pages/agent/MySquad";
import PitchPlayer from "../pages/agent/PitchPlayer";
import InvitePlayer from "../pages/agent/InvitePlayer";
// TP-Coach-Mandate — agency-side coach/staff mandates (flag-gated, dormant).
import InviteStaff from "../pages/agent/InviteStaff";
import { STAFF_MANDATE_ENABLED } from "../config/featureFlags";
// Agent-Tender feature (agent-only marketplace with club-verified requests)
import AgentTenderFeed from "../pages/agent-tender/AgentTenderFeed";
import MyAgentTenders from "../pages/agent-tender/MyAgentTenders";
import CreateAgentTender from "../pages/agent-tender/CreateAgentTender";
import EditAgentTender from "../pages/agent-tender/EditAgentTender";
import PitchToAgentTender from "../pages/agent-tender/PitchToAgentTender";
import AgentTenderVerifyPublic from "../pages/agent-tender/AgentTenderVerifyPublic";
// Club-Network (N2) — club-facing Agent Requests browse + contact.
import ClubNetworkFeed from "../pages/club-network/ClubNetworkFeed";
import ClubNetworkRequestDetail from "../pages/club-network/ClubNetworkRequestDetail";
// Club-Network (N3) — Trusted Agent (club search requests + agent inbox).
import TrustedAgentHome from "../pages/club-network/TrustedAgentHome";
import SearchRequestDetail from "../pages/club-network/SearchRequestDetail";
import CreateSearchRequest from "../pages/club-network/CreateSearchRequest";
import AgentSearchInbox from "../pages/club-network/AgentSearchInbox";
// QCS-T5 — commissioned-search delivery UI (agent deliver flow + club proposals).
import DeliverSearchRequest from "../pages/club-network/DeliverSearchRequest";
import ClubDeliveryView from "../pages/club-network/ClubDeliveryView";
import CommissionedRequestView from "../pages/club-network/CommissionedRequestView";
// Scout Requests (M2 — club side under /scouting/). M3 adds the AGENT side under
// /scout-requests… (browse, detail, my-recommendations).
import OurScoutRequests from "../pages/scout-request/OurScoutRequests";
import RecommendationsInbox from "../pages/scout-request/RecommendationsInbox";
// TP Club Radar — the club's shared watchlist (P3). Replaces the old scout-request
// grouped "Radar" page at the canonical /scouting/radar (route kept so deep-links
// + the BE forward-card cta_path stay valid).
import ClubRadar from "../pages/club-radar/ClubRadar";
import ClubRadarSnapshot from "../pages/club-radar/ClubRadarSnapshot";
import ScoutRequestFeed from "../pages/scout-request/ScoutRequestFeed";
import ScoutRequestDetail from "../pages/scout-request/ScoutRequestDetail";
import MyRecommendations from "../pages/scout-request/MyRecommendations";
// Agent Lounge (QAL-T3) — agents-only feed + composer.
import LoungeFeed from "../pages/lounge/LoungeFeed";
import LoungePostDetail from "../pages/lounge/LoungePostDetail";
// TP Agent Radar — personal shortlists (agent side).
import AgentRadar from "../pages/agent-radar/AgentRadar";
import RadarSnapshot from "../pages/agent-radar/RadarSnapshot";
// TP-Last-Minute — agent side (M2): supply-side listings composer + My Listings.
import LastMinutePage from "../pages/last-minute/LastMinutePage";
import MyListingsPage from "../pages/last-minute/MyListingsPage";
import ReceivedRequestsPage from "../pages/last-minute/ReceivedRequestsPage";
// TP-Friendlies — club-only club↔club friendly matchmaking (M2 browse + apply,
// M3 composer/management/my-applications).
import FriendliesPage from "../pages/friendlies/FriendliesPage";
import MyFriendliesPage from "../pages/friendlies/MyFriendliesPage";
import MyApplicationsPage from "../pages/friendlies/MyApplicationsPage";
import AgencyProfile from "../pages/agency/AgencyProfile";
import AgencyPitches from "../pages/agency/AgencyPitches";
import AgencyTaskboard from "../pages/agency/AgencyTaskboard";
import AgencyPlayerEntries from "../pages/agency/AgencyPlayerEntries";
import AddManualEntry from "../pages/agency/AddManualEntry";
import FolderDetail from "../pages/agency/FolderDetail";
import Inbox from "../pages/Inbox";
import DocumentManager from "../pages/document/DocumentManager";
import CreateContract from "../pages/document/CreateContract";
import CreateTemplate from "../pages/document/CreateTemplate";
import EditSignature from "../pages/document/EditSignature";
import SignDocument from "../pages/document/SignDocument";
import Notifications from "../pages/Notifications";
import Meetings from "../pages/Meetings";
import MeetingDetails from "../pages/MeetingDetails";
import ContactsPage from "../pages/Contacts";
import Profile from "../pages/Profile";
import SecuritySettings from "../pages/settings/SecuritySettings";
import NotificationSettings from "../pages/settings/NotificationSettings";
import LawyerProfileSettings from "../pages/settings/LawyerProfileSettings";
import FAQ from "../pages/FAQ";
import TransferWindows from "../pages/TransferWindows";
import Leaderboard from "../pages/Leaderboard";
import AgencyPublicProfile from "../pages/search/AgencyPublicProfile";
import CoachProfile from "../pages/search/CoachProfile";
import ForgotPassword from "../pages/auth/ForgotPassword";
import KeepTenderActive from "../pages/KeepTenderActive";
import ChangePassword from "../pages/auth/ChangePassword";
import KycVerification from "../pages/auth/KycVerification";
import StaffTenders from "../pages/Staff/StaffTenders";
import StaffViewPitches from "../pages/Staff/StaffViewPitches";
import StaffPitchTender from "../pages/Staff/StaffPitchTender";
// Coach pages - will be created in Phase 4
import CoachTenders from "../pages/Coach/CoachTenders";
import CoachViewPitches from "../pages/Coach/CoachViewPitches";
import CoachPitchTender from "../pages/Coach/CoachPitchTender";
import RolesAndResponsibilities from "../pages/club/RolesAndResponsibilities";
// Banned Agents (club settings) — the silent agent ban's management page.
import BannedAgents from "../pages/club/BannedAgents";
import PlayerMandateSelection from "../pages/auth/PlayerMandateSelection";
// TP-Coach-Mandate — public staff/coach invitee chain (mirror of the
// PlayerMandate* pages; legacy /kyc DocuPass page + dead MobileVerification
// stub deliberately NOT mirrored — only live pages).
import StaffMandateSelection from "../pages/auth/StaffMandateSelection";
import StaffMandateKycStart from "../pages/auth/StaffMandateKycStart";
import StaffMandateBiometricVerification from "../pages/auth/StaffMandateBiometricVerification";
import StaffMandateKycRejected from "../pages/auth/StaffMandateKycRejected";
import StaffMandateResponse from "../pages/auth/StaffMandateResponse";
import StaffMandateSuccess from "../pages/auth/StaffMandateSuccess";
import StaffMandateDeclined from "../pages/auth/StaffMandateDeclined";
import PlayerMandateKycStart from "../pages/auth/PlayerMandateKycStart";
import PlayerMandateKycVerification from "../pages/auth/PlayerMandateKycVerification";
import PlayerMandateBiometricVerification from "../pages/auth/PlayerMandateBiometricVerification";
import PlayerMandateKycRejected from "../pages/auth/PlayerMandateKycRejected";
import PlayerMandateResponse from "../pages/auth/PlayerMandateResponse";
import PlayerMandateSuccess from "../pages/auth/PlayerMandateSuccess";
import PlayerMandateDeclined from "../pages/auth/PlayerMandateDeclined";
import { ROLES } from "../config/roles";
import maintenanceMode from "../utils/maintenanceMode";
import MaintenanceMode from "../components/common/MaintenanceMode";
import MobileSplash from "../pages/MobileSplash";
import NotFound from "../pages/NotFound";

const AppRoutes = () => {
  console.log("Routes - Rendering");
  if (maintenanceMode.isEnabled()) {
    return <MaintenanceMode />;
  }
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/register" element={<SignUp />} />
      <Route path="/login" element={<SignIn />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      {/* No-auth landing for the tender keep-alive email button */}
      <Route path="/keep-tender-active/:token" element={<KeepTenderActive />} />
      {/* No-auth public page for a club contact to confirm an agent tender */}
      <Route
        path="/verify/agent-tender/:token"
        element={<AgentTenderVerifyPublic />}
      />

      {/* Onboarding Route - No header/navigation */}
      <Route path="/onboarding" element={<Onboarding />} />

      <Route path="/splash" element={<MobileSplash />} />

      {/* KYC Verification Route - No header/navigation */}
      <Route path="/kyc-verification" element={<KycVerification />} />
      <Route path="/kyc_verification" element={<KycVerification />} />

      {/* Private Routes with Header */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        }
      />
      <Route
        path="/inbox"
        element={
          <PrivateRoute>
            <Inbox />
          </PrivateRoute>
        }
      />
      <Route
        path="/notifications"
        element={
          <PrivateRoute>
            <Notifications />
          </PrivateRoute>
        }
      />
      <Route
        path="/search"
        element={
          <PrivateRoute>
            <Search />
          </PrivateRoute>
        }
      />
      <Route
        path="/club/tenders"
        element={
          <PrivateRoute
            allowedRoles={[ROLES.ClubAdmin]}
            requiredPermission="view_tenders"
          >
            <ClubTenders />
          </PrivateRoute>
        }
      />
      <Route
        path="/club/tenders/create"
        element={
          <PrivateRoute requiredPermission="create_tenders">
            <CreateTender />
          </PrivateRoute>
        }
      />
      <Route
        path="/club/tenders/:tenderId/edit"
        element={
          <PrivateRoute requiredPermission="create_tenders">
            <EditTender />
          </PrivateRoute>
        }
      />
      <Route
        path="/club"
        element={
          <PrivateRoute allowedRoles={[ROLES.ClubAdmin]}>
            <MyClub />
          </PrivateRoute>
        }
      />
      <Route
        path="/club/player-availability"
        element={
          <PrivateRoute requiredPermission="edit_squad">
            <ChangePlayerAvailability />
          </PrivateRoute>
        }
      />
      <Route
        path="/club/invite-staff"
        element={
          <PrivateRoute
            allowedRoles={[ROLES.ClubAdmin, ROLES.Coach, ROLES.Staff]}
            requiredPermission="invite_new_staff"
          >
            <InviteStaffPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/club/tenders/:tenderId/pitches"
        element={
          <PrivateRoute>
            <ViewPitches />
          </PrivateRoute>
        }
      />
      <Route
        path="/search/player/:playerId"
        element={
          <PrivateRoute>
            <PlayerProfile />
          </PrivateRoute>
        }
      />
      <Route
        path="/search/staff/:staffId"
        element={
          <PrivateRoute>
            <StaffProfile />
          </PrivateRoute>
        }
      />
      <Route
        path="/search/agent/:agentId"
        element={
          <PrivateRoute>
            <AgentPublicProfile />
          </PrivateRoute>
        }
      />
      <Route
        path="/search/coach/:coachId"
        element={
          <PrivateRoute>
            <CoachProfile />
          </PrivateRoute>
        }
      />
      <Route
        path="/organizers"
        element={
          <PrivateRoute>
            <Organizers />
          </PrivateRoute>
        }
      />
      <Route
        path="/lawyers"
        element={
          <PrivateRoute
            allowedRoles={[
              ROLES.Agent,
              ROLES.AgencyAdmin,
              ROLES.Staff,
              ROLES.ClubAdmin,
              ROLES.Organizer,
              ROLES.Lawyer,
              ROLES.Coach
            ]}
          >
            <Lawyers />
          </PrivateRoute>
        }
      />
      <Route
        path="/search/club/:clubId"
        element={
          <PrivateRoute>
            <ClubProfile />
          </PrivateRoute>
        }
      />
      <Route
        path="/discovery"
        element={
          <PrivateRoute>
            <Discovery />
          </PrivateRoute>
        }
      />
      <Route
        path="/competitions"
        element={
          <PrivateRoute>
            <CompetitionsBrowse />
          </PrivateRoute>
        }
      />
      <Route
        path="/competitions/:id"
        element={
          <PrivateRoute>
            <CompetitionPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/compare"
        element={
          <PrivateRoute>
            <Compare />
          </PrivateRoute>
        }
      />
      <Route
        path="/team-of-the-week"
        element={
          <PrivateRoute>
            <TeamOfTheWeek />
          </PrivateRoute>
        }
      />
      <Route
        path="/market"
        element={
          <PrivateRoute>
            <Market />
          </PrivateRoute>
        }
      />
      {/* /integrations retired (Marin, 2026-08-06). The page was built for
          third-party integrations; its only real card was the "Smrt stats"
          mock, dropped in #335 as a future topic. What remained was a
          "Talk to Organizer" card whose button merely redirected to
          /organizers — a page that already sits in the main menu under
          Network and offers a Contact button per organizer, gated on the
          same talk_to_organizer permission. Integrations has nothing to do
          with organizers, and nothing in the product ever linked here. */}
      <Route
        path="/club/roles"
        element={
          <PrivateRoute
            allowedRoles={[ROLES.ClubAdmin]}
            requiredPermission="edit_roles"
          >
            <RolesAndResponsibilities />
          </PrivateRoute>
        }
      />
      {/* Banned Agents. PART A: "every club member who has access to Club
          Tenders — the same permission gates this menu". That permission is
          `view_tenders` (the gate on /club/tenders above); the roles are the
          three club-side roles that have a Tenders surface at all. */}
      <Route
        path="/club/banned-agents"
        element={
          <PrivateRoute
            allowedRoles={[ROLES.ClubAdmin, ROLES.Staff, ROLES.Coach]}
            requiredPermission="view_tenders"
          >
            <BannedAgents />
          </PrivateRoute>
        }
      />
      <Route
        path="/market"
        element={
          <PrivateRoute>
            <Market />
          </PrivateRoute>
        }
      />
      <Route
        path="/news"
        element={
          <PrivateRoute>
            <TransferNews />
          </PrivateRoute>
        }
      />
      <Route
        path="/whats-new"
        element={
          <PrivateRoute>
            <WhatsNew />
          </PrivateRoute>
        }
      />
      <Route
        path="/news/:articleId"
        element={
          <PrivateRoute>
            <ArticleDetailPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/events"
        element={
          <PrivateRoute>
            <Events />
          </PrivateRoute>
        }
      />
      <Route
        path="/invitations"
        element={
          <PrivateRoute
            allowedRoles={[ROLES.Agent, ROLES.AgencyAdmin, ROLES.ClubAdmin]}
          >
            <SentInvitations />
          </PrivateRoute>
        }
      />

      {/* Agent-Tender marketplace (Agent + AgencyAdmin; club roles see nothing) */}
      <Route
        path="/agent-tenders"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent, ROLES.AgencyAdmin]}>
            <AgentTenderFeed />
          </PrivateRoute>
        }
      />
      <Route
        path="/agent-tenders/mine"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent, ROLES.AgencyAdmin]}>
            <MyAgentTenders />
          </PrivateRoute>
        }
      />
      <Route
        path="/agent-tenders/create"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent, ROLES.AgencyAdmin]}>
            <CreateAgentTender />
          </PrivateRoute>
        }
      />
      <Route
        path="/agent-tenders/:id/edit"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent, ROLES.AgencyAdmin]}>
            <EditAgentTender />
          </PrivateRoute>
        }
      />
      <Route
        path="/agent-tenders/:id/pitch"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent, ROLES.AgencyAdmin]}>
            <PitchToAgentTender />
          </PrivateRoute>
        }
      />

      {/* Club-Network N2 — club-facing Agent Requests (browse + contact).
          Club roles only; the anonymised feed never resolves a club. */}
      <Route
        path="/network/agent-requests"
        element={
          <PrivateRoute allowedRoles={[ROLES.ClubAdmin, ROLES.Staff, ROLES.Coach]}>
            <ClubNetworkFeed />
          </PrivateRoute>
        }
      />
      <Route
        path="/network/agent-requests/:id"
        element={
          <PrivateRoute allowedRoles={[ROLES.ClubAdmin, ROLES.Staff, ROLES.Coach]}>
            <ClubNetworkRequestDetail />
          </PrivateRoute>
        }
      />

      {/* Club-Network N3 — Trusted Agent. Club roles own the search requests;
          agents receive them in their (non-anonymous) inbox. */}
      <Route
        path="/network/trusted-agent"
        element={
          <PrivateRoute allowedRoles={[ROLES.ClubAdmin, ROLES.Staff, ROLES.Coach]}>
            <TrustedAgentHome />
          </PrivateRoute>
        }
      />
      <Route
        path="/network/trusted-agent/new"
        element={
          <PrivateRoute allowedRoles={[ROLES.ClubAdmin, ROLES.Staff, ROLES.Coach]}>
            <CreateSearchRequest />
          </PrivateRoute>
        }
      />
      <Route
        path="/network/trusted-agent/:id"
        element={
          <PrivateRoute allowedRoles={[ROLES.ClubAdmin, ROLES.Staff, ROLES.Coach]}>
            <SearchRequestDetail />
          </PrivateRoute>
        }
      />
      {/* A2/A3 — the club's read-only delivery view (opens from "View proposals"). */}
      <Route
        path="/network/trusted-agent/:id/delivery"
        element={
          <PrivateRoute allowedRoles={[ROLES.ClubAdmin, ROLES.Staff, ROLES.Coach]}>
            <ClubDeliveryView />
          </PrivateRoute>
        }
      />
      {/* A7 — the club's read-only view of the LIVE commissioned request
          (opens from the winner row's "Searching ↗"). */}
      <Route
        path="/network/trusted-agent/:id/live"
        element={
          <PrivateRoute allowedRoles={[ROLES.ClubAdmin, ROLES.Staff, ROLES.Coach]}>
            <CommissionedRequestView />
          </PrivateRoute>
        }
      />
      <Route
        path="/network/search-requests/inbox"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent, ROLES.AgencyAdmin]}>
            <AgentSearchInbox />
          </PrivateRoute>
        }
      />
      {/* B3/B3b — the commissioned agent's deliver flow (proposals + empty path). */}
      <Route
        path="/network/search-requests/:id/deliver"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent, ROLES.AgencyAdmin]}>
            <DeliverSearchRequest />
          </PrivateRoute>
        }
      />

      {/* Scout Requests — CLUB side (M2). Club roles post scouting demand, read
          their private recommendations inbox, and curate the radar. Mega-menu
          entry lands here in M4; the pages are reachable by URL now. */}
      <Route
        path="/scouting/requests"
        element={
          <PrivateRoute allowedRoles={[ROLES.ClubAdmin, ROLES.Staff, ROLES.Coach]}>
            <OurScoutRequests />
          </PrivateRoute>
        }
      />
      <Route
        path="/scouting/requests/:id/recommendations"
        element={
          <PrivateRoute allowedRoles={[ROLES.ClubAdmin, ROLES.Staff, ROLES.Coach]}>
            <RecommendationsInbox />
          </PrivateRoute>
        }
      />
      {/* Club Radar (P3): the pure watchlist. ONE canonical route — the new page
          takes over /scouting/radar (deep-links + the BE forward-card cta_path stay
          valid; mega-menu entry unchanged). Role gate stays broad; the page itself
          enforces the access_radar permission (R9). */}
      <Route
        path="/scouting/radar"
        element={
          <PrivateRoute allowedRoles={[ROLES.ClubAdmin, ROLES.Staff, ROLES.Coach]}>
            <ClubRadar />
          </PrivateRoute>
        }
      />
      {/* Club shared-list snapshot — bare PrivateRoute (any chat-capable user can
          open a shared snapshot; the BE scopes the read to owner-or-recipient).
          The club_radar_shortlist_share card's cta_path targets this path. */}
      <Route
        path="/scouting/radar/snapshots/:id"
        element={
          <PrivateRoute>
            <ClubRadarSnapshot />
          </PrivateRoute>
        }
      />

      {/* TP Agent Radar — personal shortlists (agent side). The snapshot view (P3)
          uses a BARE PrivateRoute — any authenticated chat-capable user (agents AND
          clubs, like /inbox) can open a shared snapshot; the BE scopes the read to
          owner-or-recipient. */}
      <Route
        path="/agent/radar"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent, ROLES.AgencyAdmin]}>
            <AgentRadar />
          </PrivateRoute>
        }
      />
      <Route
        path="/agent/radar/snapshots/:id"
        element={
          <PrivateRoute>
            <RadarSnapshot />
          </PrivateRoute>
        }
      />

      {/* Scout Requests — AGENT side (M3). Agents browse the public demand feed,
          recommend players, and track their own recommendations. The static
          /my-recommendations path is declared before /:id (v6 ranks static over
          dynamic, but the order keeps intent obvious). */}
      <Route
        path="/scout-requests"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent, ROLES.AgencyAdmin]}>
            <ScoutRequestFeed />
          </PrivateRoute>
        }
      />
      <Route
        path="/scout-requests/my-recommendations"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent, ROLES.AgencyAdmin]}>
            <MyRecommendations />
          </PrivateRoute>
        }
      />
      <Route
        path="/scout-requests/:id"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent, ROLES.AgencyAdmin]}>
            <ScoutRequestDetail />
          </PrivateRoute>
        }
      />

      {/* Agent Lounge (QAL-T3/T4) — agents-only feed + composer + post
          detail. Behind the normal KYC gate (deliberately NOT in
          NON_KYC_ROUTES, Gate-0 §4). */}
      <Route
        path="/lounge"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent, ROLES.AgencyAdmin]}>
            <LoungeFeed />
          </PrivateRoute>
        }
      />
      <Route
        path="/lounge/:postId"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent, ROLES.AgencyAdmin]}>
            <LoungePostDetail />
          </PrivateRoute>
        }
      />

      {/* TP-Last-Minute — agent side (M2). Agents publish supply-side listings and
          manage them in My Listings. The club browse opens up in M3; the "compose"
          query param on /last-minute opens the shared composer (both entry points,
          Invariant 13). Agent + AgencyAdmin only for now (M3 gates the club view). */}
      <Route
        path="/last-minute"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent, ROLES.AgencyAdmin, ROLES.ClubAdmin, ROLES.Staff, ROLES.Coach]}>
            <LastMinutePage />
          </PrivateRoute>
        }
      />
      <Route
        path="/last-minute/my-listings"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent, ROLES.AgencyAdmin]}>
            <MyListingsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/last-minute/requests/received"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent, ROLES.AgencyAdmin]}>
            <ReceivedRequestsPage />
          </PrivateRoute>
        }
      />

      {/* TP-Friendlies — club-only browse + apply (M2). Composer, management, My
          applications, and nav come in M3/M4. Agents are excluded API-wide. */}
      <Route
        path="/friendlies"
        element={
          <PrivateRoute allowedRoles={[ROLES.ClubAdmin, ROLES.Staff, ROLES.Coach]}>
            <FriendliesPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/friendlies/mine"
        element={
          <PrivateRoute allowedRoles={[ROLES.ClubAdmin, ROLES.Staff, ROLES.Coach]}>
            <MyFriendliesPage />
          </PrivateRoute>
        }
      />
      {/* Alias for the server-persisted notification redirect_path ('/friendlies/requests'). */}
      <Route
        path="/friendlies/requests"
        element={
          <PrivateRoute allowedRoles={[ROLES.ClubAdmin, ROLES.Staff, ROLES.Coach]}>
            <MyFriendliesPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/friendlies/applications"
        element={
          <PrivateRoute allowedRoles={[ROLES.ClubAdmin, ROLES.Staff, ROLES.Coach]}>
            <MyApplicationsPage />
          </PrivateRoute>
        }
      />

      {/* Agent Routes */}
      <Route
        path="/agent/tenders"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent]}>
            <AgentTenders />
          </PrivateRoute>
        }
      />

      <Route
        path="/agent/mysquad"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent]}>
            <MySquad />
          </PrivateRoute>
        }
      />
      <Route
        path="/agent/tenders/:tenderId/pitch"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent]}>
            <PitchPlayer />
          </PrivateRoute>
        }
      />
      <Route
        path="/agent/invite-player"
        element={
          <PrivateRoute allowedRoles={[ROLES.Agent]}>
            <InvitePlayer />
          </PrivateRoute>
        }
      />
      {/* TP-Coach-Mandate: "Invite staff" twin of the invite-player route
          (Brief §4.1). Flag-gated — flag off ⇒ route absent (dormant). */}
      {STAFF_MANDATE_ENABLED && (
        <Route
          path="/agent/invite-staff"
          element={
            <PrivateRoute allowedRoles={[ROLES.Agent]}>
              <InviteStaff />
            </PrivateRoute>
          }
        />
      )}

      {/* Agency Routes */}
      <Route
        path="/agency"
        element={
          <PrivateRoute allowedRoles={[ROLES.AgencyAdmin]}>
            <AgencyProfile />
          </PrivateRoute>
        }
      />
      <Route
        path="/agency/invite-player"
        element={
          <PrivateRoute allowedRoles={[ROLES.AgencyAdmin]}>
            <InvitePlayer />
          </PrivateRoute>
        }
      />
      {/* TP-Coach-Mandate: agency-mode invite-staff twin (flag-gated). */}
      {STAFF_MANDATE_ENABLED && (
        <Route
          path="/agency/invite-staff"
          element={
            <PrivateRoute allowedRoles={[ROLES.AgencyAdmin]}>
              <InviteStaff />
            </PrivateRoute>
          }
        />
      )}
      <Route
        path="/search/agency/:agencyId"
        element={
          <PrivateRoute>
            <AgencyPublicProfile />
          </PrivateRoute>
        }
      />

      <Route
        path="/agency/pitches"
        element={
          <PrivateRoute allowedRoles={[ROLES.AgencyAdmin]}>
            <AgencyPitches />
          </PrivateRoute>
        }
      />
      <Route
        path="/agency/taskboard"
        element={
          <PrivateRoute allowedRoles={[ROLES.AgencyAdmin, ROLES.Agent]}>
            <AgencyTaskboard />
          </PrivateRoute>
        }
      />

      {/* New folder-based detail page. Replaces the old per-player
          /agency/player/:id/entries flow. The legacy routes below
          stay around so any deep-link from before the migration still
          resolves rather than 404'ing. */}
      <Route
        path="/agency/folders/:folderId"
        element={
          <PrivateRoute allowedRoles={[ROLES.AgencyAdmin, ROLES.Agent]}>
            <FolderDetail />
          </PrivateRoute>
        }
      />

      <Route
        path="/agency/player/:id/entries"
        element={
          <PrivateRoute allowedRoles={[ROLES.AgencyAdmin, ROLES.Agent]}>
            <AgencyPlayerEntries />
          </PrivateRoute>
        }
      />
      <Route
        path="/agency/add-manual-entry"
        element={
          <PrivateRoute allowedRoles={[ROLES.AgencyAdmin, ROLES.Agent]}>
            <AddManualEntry />
          </PrivateRoute>
        }
      />

      {/* Document Routes */}
      <Route
        path="/documents"
        element={
          <PrivateRoute
            allowedRoles={[ROLES.ClubAdmin, ROLES.Agent, ROLES.Staff, ROLES.Coach]}
          >
            <DocumentManager />
          </PrivateRoute>
        }
      />
      <Route
        path="/documents/create-contract"
        element={
          <PrivateRoute
            allowedRoles={[ROLES.ClubAdmin, ROLES.Agent, ROLES.Staff, ROLES.Coach]}
          >
            <CreateContract />
          </PrivateRoute>
        }
      />
      <Route
        path="/documents/create-template"
        element={
          <PrivateRoute
            allowedRoles={[ROLES.ClubAdmin, ROLES.Agent, ROLES.Staff, ROLES.Coach]}
          >
            <CreateTemplate />
          </PrivateRoute>
        }
      />
      <Route
        path="/documents/edit-signature"
        element={
          <PrivateRoute
            allowedRoles={[ROLES.ClubAdmin, ROLES.Agent, ROLES.Staff, ROLES.Coach]}
          >
            <EditSignature />
          </PrivateRoute>
        }
      />
      <Route
        path="/documents/sign/:documentId"
        element={
          <PrivateRoute
            allowedRoles={[ROLES.ClubAdmin, ROLES.Agent, ROLES.Staff, ROLES.Coach]}
          >
            <SignDocument />
          </PrivateRoute>
        }
      />

      {/* Meetings Routes */}
      <Route
        path="/meetings"
        element={
          <PrivateRoute>
            <Meetings />
          </PrivateRoute>
        }
      />
      <Route
        path="/meetings/:meetingId"
        element={
          <PrivateRoute>
            <MeetingDetails />
          </PrivateRoute>
        }
      />

      <Route
        path="/transfer-windows"
        element={
          <PrivateRoute>
            <TransferWindows />
          </PrivateRoute>
        }
      />

      <Route
        path="/leaderboard"
        element={
          <PrivateRoute>
            <Leaderboard />
          </PrivateRoute>
        }
      />

      {/* New routes for contacts and profile */}
      <Route
        path="/contacts"
        element={
          <PrivateRoute>
            <ContactsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        }
      />
      <Route
        path="/faq"
        element={
          <PrivateRoute>
            <FAQ />
          </PrivateRoute>
        }
      />
      <Route
        path="/profile/business-card"
        element={<Navigate to="/profile?tab=business-card" replace />}
      />

      {/* Password Change Route (for authenticated users) */}
      <Route
        path="/change-password"
        element={
          <PrivateRoute>
            <ChangePassword />
          </PrivateRoute>
        }
      />

      {/* Security settings — Trusted Devices manager. */}
      <Route
        path="/settings/security"
        element={
          <PrivateRoute>
            <SecuritySettings />
          </PrivateRoute>
        }
      />

      {/* Notification settings: per-category in-app/email + master mute. */}
      <Route
        path="/settings/notifications"
        element={
          <PrivateRoute>
            <NotificationSettings />
          </PrivateRoute>
        }
      />

      {/* Lawyer profile settings — role-gated content inside; any authed user
          can reach it to add the lawyer role (additive, no per-role gate on the
          route so existing users can opt in). */}
      <Route
        path="/settings/lawyer-profile"
        element={
          <PrivateRoute>
            <LawyerProfileSettings />
          </PrivateRoute>
        }
      />

      {/* Staff Routes */}
      <Route
        path="/staff/tenders"
        element={
          <PrivateRoute allowedRoles={[ROLES.Staff]}>
            <StaffTenders />
          </PrivateRoute>
        }
      />
      <Route
        path="/staff/myclub"
        element={
          <PrivateRoute
            allowedRoles={[ROLES.Staff]}
            requiredPermission={["edit_squad", "invite_new_staff"]}
          >
            <MyClub />
          </PrivateRoute>
        }
      />
      <Route
        path="/staff/tenders/:tenderId/pitches"
        element={
          <PrivateRoute
            allowedRoles={[ROLES.Staff]}
            requiredPermission="view_pitches"
          >
            <StaffViewPitches />
          </PrivateRoute>
        }
      />

      <Route
        path="/staff/tenders/:tenderId/pitch"
        element={
          <PrivateRoute allowedRoles={[ROLES.Staff]}>
            <StaffPitchTender />
          </PrivateRoute>
        }
      />

      {/* Coach Routes */}
      <Route
        path="/coach/tenders"
        element={
          <PrivateRoute allowedRoles={[ROLES.Coach]}>
            <CoachTenders />
          </PrivateRoute>
        }
      />
      <Route
        path="/coach/myclub"
        element={
          <PrivateRoute
            allowedRoles={[ROLES.Coach]}
            requiredPermission={["edit_squad", "invite_new_staff"]}
          >
            <MyClub />
          </PrivateRoute>
        }
      />
      <Route
        path="/coach/tenders/:tenderId/pitches"
        element={
          <PrivateRoute
            allowedRoles={[ROLES.Coach]}
            requiredPermission="view_pitches"
          >
            <CoachViewPitches />
          </PrivateRoute>
        }
      />
      <Route
        path="/coach/tenders/:tenderId/pitch"
        element={
          <PrivateRoute allowedRoles={[ROLES.Coach]}>
            <CoachPitchTender />
          </PrivateRoute>
        }
      />

      {/* Lawyer Routes */}
      <Route
        path="/lawyer"
        element={
          <PrivateRoute allowedRoles={[ROLES.Lawyer]}>
            <div className="p-8">
              <h1 className="text-2xl font-bold">Lawyer Dashboard</h1>
              <p className="text-gray-600 mt-2">Welcome to your lawyer dashboard.</p>
            </div>
          </PrivateRoute>
        }
      />
      {/* D-011: lawyer-only staff-request feed + apply. Backend scopes the
          list to tender_category=staff + active for a lawyer token. */}
      <Route
        path="/lawyer/tenders"
        element={
          <PrivateRoute allowedRoles={[ROLES.Lawyer]}>
            <LawyerRequests />
          </PrivateRoute>
        }
      />

      {/* Player mandate routes - Public routes (no auth required) */}
      <Route path="/player-register-mandate" element={<PlayerMandateSelection />} />
      <Route path="/player-register-mandate/:token" element={<PlayerMandateSelection />} />
      <Route path="/player-register-mandate/:token/verify" element={<PlayerMandateKycStart />} />
      <Route path="/player-register-mandate/:token/kyc" element={<PlayerMandateKycVerification />} />
      <Route path="/player-register-mandate/:token/biometric-verification" element={<PlayerMandateBiometricVerification />} />
      <Route path="/player-register-mandate/:token/rejected" element={<PlayerMandateKycRejected />} />
      <Route path="/player-register-mandate/:token/action" element={<PlayerMandateResponse />} />
      <Route path="/player-register-mandate/:token/success" element={<PlayerMandateSuccess />} />
      <Route path="/player-register-mandate/:token/declined" element={<PlayerMandateDeclined />} />
      {/* Legacy routes for backward compatibility */}
      <Route path="/player-register-mandate/verify" element={<PlayerMandateKycStart />} />
      <Route path="/player-register-mandate/kyc" element={<PlayerMandateKycVerification />} />
      <Route path="/player-register-mandate/biometric-verification" element={<PlayerMandateBiometricVerification />} />
      <Route path="/player-register-mandate/rejected" element={<PlayerMandateKycRejected />} />
      <Route path="/player-register-mandate/action" element={<PlayerMandateResponse />} />
      <Route path="/player-register-mandate/success" element={<PlayerMandateSuccess />} />
      <Route path="/player-register-mandate/declined" element={<PlayerMandateDeclined />} />

      {/* TP-Coach-Mandate: staff/coach mandate routes — public (no auth
          required), mirroring the player-register-mandate block above.
          Order: Selection → verify → biometric → action → success|declined;
          no /kyc leg (the coach chain is pure biometric). */}
      <Route path="/staff-register-mandate" element={<StaffMandateSelection />} />
      <Route path="/staff-register-mandate/:token" element={<StaffMandateSelection />} />
      <Route path="/staff-register-mandate/:token/verify" element={<StaffMandateKycStart />} />
      <Route path="/staff-register-mandate/:token/biometric-verification" element={<StaffMandateBiometricVerification />} />
      <Route path="/staff-register-mandate/:token/rejected" element={<StaffMandateKycRejected />} />
      <Route path="/staff-register-mandate/:token/action" element={<StaffMandateResponse />} />
      <Route path="/staff-register-mandate/:token/success" element={<StaffMandateSuccess />} />
      <Route path="/staff-register-mandate/:token/declined" element={<StaffMandateDeclined />} />
      {/* Tokenless twins (state/query-token driven, mirroring the legacy
          player block) */}
      <Route path="/staff-register-mandate/verify" element={<StaffMandateKycStart />} />
      <Route path="/staff-register-mandate/biometric-verification" element={<StaffMandateBiometricVerification />} />
      <Route path="/staff-register-mandate/rejected" element={<StaffMandateKycRejected />} />
      <Route path="/staff-register-mandate/action" element={<StaffMandateResponse />} />
      <Route path="/staff-register-mandate/success" element={<StaffMandateSuccess />} />
      <Route path="/staff-register-mandate/declined" element={<StaffMandateDeclined />} />

      {/* Catch-all (T041): an unknown path used to render a blank white page
          — no shell, no 404. Wrapped in PrivateRoute so the guard keeps its
          normal behaviour: an unauthenticated visitor on a bad URL still gets
          the usual /login (or /splash on mobile) redirect, and only a signed-in
          user sees the not-found state inside the app shell. MUST stay last. */}
      <Route
        path="*"
        element={
          <PrivateRoute>
            <NotFound />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
